import { Paragraph, SyntaxIcon } from '@expressable/syntax-ds';
import { Clock, User } from '@phosphor-icons/react';
import clsx from 'clsx';

export const DateChipAdornment = ({ count, disabled }: { count: number; disabled?: boolean }) => (
  <Paragraph size="xs" className={clsx('flex gap-e4', { 'text-disabled': disabled })}>
    {count}{' '}
    <SyntaxIcon
      icon={User}
      weight="fill"
      className={`${disabled ? 'text-warm-gray-400' : 'text-purple-400'}`}
    ></SyntaxIcon>
  </Paragraph>
);

export const TimeSlotChipAdornment = ({ count, disabled }: { count: number; disabled?: boolean }) => (
  <Paragraph size="xs" className={clsx('flex gap-e4', { 'text-disabled': disabled })}>
    {count} <SyntaxIcon icon={Clock} weight="fill" className={`${disabled ? 'text-warm-gray-400' : 'text-purple-400'}`}></SyntaxIcon>
  </Paragraph>
);
